/**
 * CANDY THEME - INTERACTIVE LOGIC & BUNDLE BUILDER
 */

document.addEventListener('DOMContentLoaded', () => {
  // initCandyBundleBuilder() is NOT called here: sections/candy-bundle-builder.liquid
  // already ships its own complete inline <script> (initCandyBundle) that binds the
  // same .candy-box-size-btn / .candy-qty-btn-* / .candy-bundle-add-to-cart-btn elements.
  // Calling both wired up two independent click handlers on the same buttons, so every
  // click doubled quantities and Add to Cart fired two separate /cart/add.js requests.
  // Function kept below, unused, for reference.
  //
  // initCandyFlashCountdowns() is NOT called here either: sections/candy-flash-deal.liquid
  // has its own inline countdown script reading the merchant-configured `end_date` setting,
  // guarded against double-init. This function ran a second setInterval on the same
  // .timer-hours/.timer-mins/.timer-secs nodes with a hardcoded fake offset, corrupting
  // the real countdown shown to customers. Function kept below, unused, for reference.
  initCandyAJAXCart();
});

/* --------------------------------------------------------------------------
   1. MIX & MATCH CANDY BUNDLE BUILDER LOGIC
   -------------------------------------------------------------------------- */
function initCandyBundleBuilder() {
  const bundleContainer = document.querySelector('.candy-bundle-builder-container');
  if (!bundleContainer) return;

  let maxWeight = parseInt(bundleContainer.dataset.maxWeight || 1000); // 1000g default
  let currentWeight = 0;
  let selectedItems = {};

  const sizeSelectorBtns = bundleContainer.querySelectorAll('.candy-box-size-btn');
  const items = bundleContainer.querySelectorAll('.candy-bundle-item');
  const fillProgressBar = bundleContainer.querySelector('.candy-box-progress-fill');
  const fillPercentageText = bundleContainer.querySelector('.candy-box-fill-percent');
  const weightText = bundleContainer.querySelector('.candy-box-current-weight');
  const maxWeightText = bundleContainer.querySelector('.candy-box-max-weight');
  const addToCartBtn = bundleContainer.querySelector('.candy-bundle-add-to-cart-btn');

  // Handle Box Size Change
  sizeSelectorBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeSelectorBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      maxWeight = parseInt(btn.dataset.weight);
      if (maxWeightText) maxWeightText.textContent = maxWeight + 'g';
      updateProgress();
    });
  });

  // Handle Item Quantity Controls
  items.forEach(item => {
    const id = item.dataset.itemId;
    const itemWeight = parseInt(item.dataset.itemWeight || 100);
    const minusBtn = item.querySelector('.candy-qty-btn-minus');
    const plusBtn = item.querySelector('.candy-qty-btn-plus');
    const qtyDisplay = item.querySelector('.candy-qty-val');

    minusBtn?.addEventListener('click', () => {
      if ((selectedItems[id] || 0) > 0) {
        selectedItems[id] = (selectedItems[id] || 0) - 1;
        currentWeight -= itemWeight;
        if (currentWeight < 0) currentWeight = 0;
        qtyDisplay.textContent = selectedItems[id];
        updateProgress();
      }
    });

    plusBtn?.addEventListener('click', () => {
      if (currentWeight + itemWeight <= maxWeight * 1.05) { // allow small threshold
        selectedItems[id] = (selectedItems[id] || 0) + 1;
        currentWeight += itemWeight;
        qtyDisplay.textContent = selectedItems[id];
        updateProgress();
      } else {
        showCandyToast('Deine Box ist bereits voll! Wähle eine größere Box für mehr Süßigkeiten.');
      }
    });
  });

  function updateProgress() {
    const percent = Math.min(100, Math.round((currentWeight / maxWeight) * 100));
    if (fillProgressBar) fillProgressBar.style.width = percent + '%';
    if (fillPercentageText) fillPercentageText.textContent = percent + '%';
    if (weightText) weightText.textContent = currentWeight + 'g';

    if (addToCartBtn) {
      if (percent >= 80) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('opacity-50');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('opacity-50');
      }
    }
  }

  // Handle Add Bundle to Cart
  addToCartBtn?.addEventListener('click', async () => {
    if (currentWeight === 0) return;
    
    addToCartBtn.textContent = '🍬 Se pregătește cutia ta...';
    
    // Construct Shopify Cart items payload
    const itemsToAdd = [];
    items.forEach(item => {
      const id = item.dataset.variantId;
      const qty = selectedItems[item.dataset.itemId] || 0;
      if (qty > 0 && id) {
        itemsToAdd.push({ id: parseInt(id), quantity: qty });
      }
    });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      if (res.ok) {
        addToCartBtn.textContent = '✅ Zur Box hinzugefügt!';
        showCandyToast('🎉 Deine individuelle Süßigkeitenbox wurde in den Warenkorb gelegt!');
        // Refresh cart drawer if present
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          addToCartBtn.textContent = '🛒 Box in den Warenkorb';
        }, 3000);
      } else {
        throw new Error('Fehler beim Hinzufügen');
      }
    } catch (err) {
      addToCartBtn.textContent = '🛒 Box in den Warenkorb';
      showCandyToast('🎉 Dulciurile au fost selectate! (Mod previzualizare)');
    }
  });
}

/* --------------------------------------------------------------------------
   2. FLASH DEAL COUNTDOWN TIMER
   -------------------------------------------------------------------------- */
function initCandyFlashCountdowns() {
  const countdowns = document.querySelectorAll('.candy-countdown-timer');
  countdowns.forEach(container => {
    const hoursEl = container.querySelector('.timer-hours');
    const minsEl = container.querySelector('.timer-mins');
    const secsEl = container.querySelector('.timer-secs');
    
    let targetTime = new Date().getTime() + (8 * 3600 * 1000 + 42 * 60 * 1000 + 15 * 1000); // 8h 42m demo

    setInterval(() => {
      const now = new Date().getTime();
      const diff = targetTime - now;

      if (diff <= 0) return;

      const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);

      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }, 1000);
  });
}

/* --------------------------------------------------------------------------
   3. TOAST NOTIFICATIONS & QUICK ADD
   -------------------------------------------------------------------------- */
function initCandyAJAXCart() {
  document.querySelectorAll('.candy-quick-add-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (btn.disabled || btn.dataset.loading === 'true') return;

      const variantId = btn.dataset.variantId;
      if (!variantId) {
        showCandyToast('⚠️ Dieses Produkt kann momentan nicht hinzugefügt werden.');
        return;
      }

      btn.dataset.loading = 'true';
      const originalText = btn.textContent;
      btn.textContent = 'Wird eingepackt...';

      // Same cart-notification/cart-drawer lookup Dawn's own product-form.js uses,
      // so the header cart bubble and drawer/notification update exactly like a
      // normal add-to-cart would.
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: [{ id: parseInt(variantId), quantity: 1 }] };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();

        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Fehler beim Hinzufügen zum Warenkorb');
        }

        btn.classList.add('candy-animate-bounce');
        showCandyToast('🍬 Produkt erfolgreich zu deiner süßen Box hinzugefügt!');
        setTimeout(() => btn.classList.remove('candy-animate-bounce'), 1000);

        if (cart) {
          cart.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        showCandyToast('⚠️ ' + (err.message || 'Das Produkt konnte nicht hinzugefügt werden. Versuch es erneut.'));
      } finally {
        btn.dataset.loading = 'false';
        btn.textContent = originalText;
      }
    });
  });
}

function showCandyToast(msg) {
  let toast = document.getElementById('candy-toast-notification');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'candy-toast-notification';
    toast.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      background: linear-gradient(135deg, #7C3AED, #FF4081);
      color: #FFF;
      padding: 14px 24px;
      border-radius: 9999px;
      font-weight: 700;
      box-shadow: 0 10px 25px rgba(124,58,237,0.3);
      z-index: 999999;
      transition: all 0.4s ease;
      transform: translateY(100px);
      opacity: 0;
    `;
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.transform = 'translateY(0)';
  toast.style.opacity = '1';
  setTimeout(() => {
    toast.style.transform = 'translateY(100px)';
    toast.style.opacity = '0';
  }, 4000);
}
